import React from 'react';
import c from 'classnames';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import SearchAllContent from '../SearchAllContent';

import { SEARCHKIT_HITS_PER_PAGE_ALL_CONTENT_AUTOSUGGEST } from '../../config/constants';
import HomepageHeroIllustrations from './Illustrations';

import './style.scss';

export interface HomepageHeroProps {
  title: string;
  body?: string;
  className?: string;
}

const HomepageHero: React.FC<HomepageHeroProps> = (props) => {
  const {
    title,
    body,
    className,
  } = props;

  const classNames = c('HomepageHero', className);

  return (
    <Container>
      <div className="row">
        <div className="col-12">
          <div className={classNames}>
            <div className="HomepageHero__content">
              <h1 className="HomepageHero__title u-word-break mb-3">
                {title}
              </h1>

              {body && (
                <WysiwygField
                  className="HomepageHero__body body--large mb-6 mb-md-8 mb-lg-12"
                  property="schema:text"
                  html={body}
                />
              )}
            </div>

            <SearchAllContent className="HomepageHero__searchbar" hitsPerPage={SEARCHKIT_HITS_PER_PAGE_ALL_CONTENT_AUTOSUGGEST} onlyFetchWithQuery>
              <SearchAllContent.SearchBarAutosuggest />
            </SearchAllContent>

            <HomepageHeroIllustrations />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default HomepageHero;
